<template>
  <div id="app" >
    <router-view v-if="!isMobile()"/>
    <MobileLayout v-else/>
  </div>

</template>

<script>
import MobileLayout  from '@/views/mobile/MobileLayout.vue'
import { isMobile } from '@/utils/device';
import {getHomeInfo,phoneCustomization,httphostCheck } from '@/api/userMG'
export default {
  name: 'App',
  components: {
    MobileLayout
  },
  data() {
    return {
    }
  },
  mounted() {  
    console.log('进入路由app.vue', this.$route.path);
    this.getInfo()
    
  },
   methods: {
    isMobile,
    async getInfo(){

        // 如果 sessionStorage 中没有 key，则先初始化
        let key = sessionStorage.getItem('key');
        if (!key) {
          key = await this.initKey();
        }
        
        const params = {
          key: key,
        };
        
        if(!isMobile()){
          getHomeInfo(params).then(res => {
            if (res.code === 200) {
                this.$store.state.HomeInfo=res.data[0];
            }
          }).catch(err => {
            console.log('初始化调用页面数据失败:',err);
          });
        }else{
          phoneCustomization(params).then(res => {
            if (res.code === 200) {
                this.$store.state.HomeInfo=res.data[0];
            }
          }).catch(err => {
            console.log('初始化调用页面数据失败:',err);
          });
        }
      },
      
      // 提取 initKey 方法到 App.vue
      async initKey() {
        const currentPath = window.location.pathname;
        const firstSegment = currentPath.split('/')[2] || '';
        try {
          // 注意：需要引入 httphostCheck 方法
          const response = await httphostCheck(firstSegment);
          const key = response.code === 200 ? response.data.id : '1';
          sessionStorage.setItem('key', key);
          return key;
        } catch (error) {
          console.error('获取域名信息失败:', error);
          sessionStorage.setItem('key', '1');
          return '1';
        }
      }
  }
  

}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
body {
    margin: 0;
    padding: 0;
}
.el-message {
  top: 80px !important; /* 消息框距顶部距离 */
}
</style>
